import { Theme } from '@mui/material/styles';
const sub = {
  '& a': {
    color: 'common.white',
    textDecoration: 'underline',
  },
  color: 'common.white',
  mb: 9,
  mt: 10,
  textAlign: 'center',
};

export const styles = {
  alert: {
    position: 'absolute',
    top: (theme: Theme) => ({
      md: theme.appNotificationHeightLargeDevice,
      xs: theme.appNotificationHeightSmallDevice,
    }),
    width: '100%',
  },
  sub: { ...sub },
  subtitle: {
    ...sub,
    mb: 5,
    mt: 0,
  },
};
